export const RATE_LIMIT_MINUTES = 3
export const RATE_LIMIT_TIME = RATE_LIMIT_MINUTES * 60 * 1000

export const DEFAULT_INFO_ICON_COPY =
  'The base area rug price is calculated using a 4x6 rug and most economical binding. Pricing varies based on size and finishing options. Wall-to-wall pricing is calculated by the square yard.'

export const DEFAULT_VIDEO_URL = {
  URL: 'https://www.youtube.com/watch?v=PDj5HBgNhm4',
  FILE: 'https://res.cloudinary.com/curran-catalog/video/upload/eo_15,fl_clip,q_75,so_0/v1686158755/Marketing/Marketing%20Videos/Curran_Showroom_Video_gt3ptk.webm',
}

export const IMAGE_COMPONENTS_TRANSFORMATIONS: Record<ContentfulComponentWithImages, { width: number; sizes: string }> =
  {
    mlVideo: {
      width: 2560,
      sizes:
        '(min-width: 2560px) 2560px, (min-width: 1280px) 1280px,(min-width: 1024px) 1024px,(min-width: 768px) 768px,(min-width: 640px)   640px,(min-width: 320px)  320px, 100vw',
    },
    mlBanner: {
      width: 2560,
      sizes:
        '(min-width: 2560px) 2560px, (min-width: 1280px) 1280px,(min-width: 1024px) 1024px,(min-width: 768px) 768px,(min-width: 640px)   640px,(min-width: 320px)  320px, 100vw',
    },
    mlVertical: {
      width: 300,
      sizes: '(max-width: 300px) 300px, 300px',
    },
    mlCard: {
      width: 1280,
      sizes: '(min-width: 640px) 300px, (min-width: 320px) 200px, 200px',
    },
    mlProductCard: {
      width: 1200,
      sizes:
        '(min-width: 1280px) 1200px,(min-width: 1024px) 500px,(min-width: 768px) 400px,(min-width: 640px)   350px,(min-width: 320px)  300px, 100vw',
    },
    mlContentStrip: {
      width: 1280,
      sizes:
        '(min-width: 2560px) 2000px, (min-width: 1280px) 1000px,(min-width: 1024px) 900px,(min-width: 768px) 650px,(min-width: 640px)   640px,(min-width: 320px)  320px, 100vw',
    },
    mlPullQuote: {
      width: 700,
      sizes:
        '(min-width: 2560px) 1400px,(min-width: 1280px) 700px,(min-width: 1024px) 600px,(min-width: 768px) 500px,(min-width: 640px)   400px,(min-width: 320px)  320px, 100vw',
    },
    mlBeautyBanner: {
      width: 700,
      sizes:
        '(min-width: 2560px) 1400px,(min-width: 1280px) 700px,(min-width: 1024px) 600px,(min-width: 768px)   500px,(min-width: 640px)   400px,(min-width: 320px)  320px, 100vw',
    },
    imageGallery: {
      width: 300,
      sizes: '(min-width: 2560px) 300px, 100vw',
    },
    beautyImageGallery: {
      width: 1400,
      sizes:
        '(min-width: 2560px) 1400px,(min-width: 1280px) 1200px,(min-width: 1024px) 1000px,(min-width: 768px)   700px,(min-width: 640px)   400px,(min-width: 320px)  320px, 100vw',
    },
    colorSelector: {
      width: 150,
      sizes:
        '(min-width: 2560px) 300px, (min-width: 1280px) 150px,(min-width: 1024px) 120px,(min-width: 768px)   100px,(min-width: 640px)   80px,(min-width: 320px)  80px, 100vw',
    },
    atIcon: {
      width: 100,
      sizes: '100px',
    },
    border: {
      width: 220,
      sizes: '220px',
    },
  }

export enum ContentfulComponentWithImages {
  mlVideo = 'mlVideo',
  mlBanner = 'mlBanner',
  mlVertical = 'mlVertical',
  mlCard = 'mlCard',
  mlContentStrip = 'mlContentStrip',
  mlPullQuote = 'mlPullQuote',
  mlBeautyBanner = 'mlBeautyBanner',
  imageGallery = 'imageGallery',
  colorSelector = 'colorSelector',
  beautyImageGallery = 'beautyImageGallery',
  atIcon = 'atIcon',
  border = 'border',
  mlProductCard = 'mlProductCard',
}
